import { connect } from 'react-redux';
import settingActions from '../redux/actions/setting_data';
import actions from '../redux/actions/setting_fee_transaction';
import SettingFeeOrderTransaction from '../component/setting_transaction_fee/SettingFeeOrderTransaction';

const mapStateToProps = (state) => ({
  coinSettings: state.setting.coinSettings,
  objCoinSettings: state.setting.objCoinSettings,
  coins: state.setting.coins,
});

const mapDispatchToProps = (dispatch) => ({
  onChangeSettingFeeTransactionAction: (params, callback) => {
    dispatch(actions.onUpdateSettingFeeAction(params, callback));
  },
  fetchCoinSetting: (params, callback) => {
    dispatch(settingActions.fetchCoinSettingAction(params, callback));
  },
  onCreateMarket: (params, callback) => {
    dispatch(settingActions.createMarketAction(params, callback));
  },
  closeMarket: (params) => {
    dispatch(settingActions.closeMarketAction(params));
  },
  openMarket: (params) => {
    dispatch(settingActions.openMarketAction(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SettingFeeOrderTransaction);
